import type { ChatLine } from '@somnhold/protocol';
import type { ChatChannel } from '../game/chat.ts';

/**
 * The keep's chat as a chat channel: lines come with the presence poll (every few seconds) and right
 * after you send one; the server keeps the last ones, so whoever opens the bastion later reads them.
 */
export class KeepChannel implements ChatChannel {
  chat: ChatLine[] = [];
  onChat: (line: ChatLine) => void = () => undefined;
  private seen = new Set<string>();
  private primed = false;

  constructor(private send: (text: string) => Promise<ChatLine[] | null>) {}

  say(text: string): void {
    void this.send(text).then((lines) => lines && this.take(lines));
  }

  /** What was said before you came: kept as it is, nothing announced. */
  prime(lines: ChatLine[]): void {
    this.primed = true;
    for (const line of lines) this.seen.add(this.key(line));
    this.chat = lines.slice();
  }

  private key(line: ChatLine): string {
    return `${line.at}|${line.pid}|${line.text}`;
  }

  /** The chat as the server has it: the lines not seen yet go to `onChat`, oldest first. */
  take(lines: ChatLine[]): void {
    if (!this.primed) return this.prime(lines);
    for (const line of lines) {
      const key = this.key(line);
      if (this.seen.has(key)) continue;
      this.seen.add(key);
      this.chat = [...this.chat, line].slice(-lines.length);
      this.onChat(line);
    }
  }
}
